import { render } from "./BillingFeatureNotice.vue?vue&type=template&id=03e32ab6&scoped=true"
import script from "./BillingFeatureNotice.vue?vue&type=script&lang=js"
export * from "./BillingFeatureNotice.vue?vue&type=script&lang=js"

import "./BillingFeatureNotice.vue?vue&type=style&index=0&id=03e32ab6&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e32ab6"]])

export default __exports__